import clsx from 'clsx'
import { Formik } from 'formik'
import isEmpty from 'lodash/isEmpty'
import noop from 'lodash/noop'
import React, { FC, useRef } from 'react'

import { Form } from '@Components/FormElements/Formik'
import { TextArea } from '@Components/FormElements/Formik/TextArea'
import { stripEmoji } from '@Components/Personalization/Util/helpers'
import measureTextPixels from '@Components/Product/GiftCardDisplay/measureText'

import styles from './giftCardMessageInput.module.scss'

interface GiftCardMessageInputProps {
  characterLimit?: number
  id?: string
  lineNumberLimit?: number
  message: string
  name?: string
  onchange?: (message: string) => void
  placeholder?: string
}

const GiftCardMessageInput: FC<GiftCardMessageInputProps> = ({
  characterLimit = 250,
  message,
  lineNumberLimit = 7,
  onchange = noop,
  name = 'GiftCardMessage',
  id = 'GiftCardMessage',
  placeholder,
}) => {
  const textAreaRef = useRef<HTMLDivElement>(null)

  const limitNewlines: (mess: string) => string = (mess) => {
    // eslint-disable-next-line no-unsafe-optional-chaining
    const textarea: HTMLTextAreaElement = textAreaRef.current!.getElementsByTagName('textarea')[0]
    if (textarea?.style) {
      const computedStyled = window.getComputedStyle(textarea)
      const padding = +computedStyled.paddingLeft.replace(/[^0-9]/g, '')
      const border = +computedStyled.borderLeftWidth.replace(/[^0-9]/g, '')
      const size = textarea!.getBoundingClientRect()!.width - ((padding + border) * 2)
      const textPixels = measureTextPixels(mess, 12)
      let lineNumbers = textPixels / size
      lineNumbers += mess.split('\n').length
      lineNumbers = Math.floor(lineNumbers)
      if (lineNumbers > lineNumberLimit) {
        return stripEmoji(message)
      }
    }
    return stripEmoji(mess)
  }

  const limitCharacters: (mess: string) => string = (mess) => {
    const newMessage = mess
    if (newMessage && newMessage.length > characterLimit) {
      return message
    }
    return mess
  }

  const changeMessage = (messageChange) => {
    let newMessage = limitCharacters(messageChange)
    newMessage = limitNewlines(newMessage)
    onchange(newMessage)
  }

  return (
    <div
      className={clsx(styles.giftCardMessageInput, styles.title)}
      ref={textAreaRef}
    >
      <Formik<GiftCardMessageInputProps>
        initialValues={{ message }}
        onSubmit={noop}
        validateOnBlur={false}
        validateOnChange={false}
      >
        <Form>
          <TextArea
            id={id}
            label={isEmpty(message) ? '' : `${message.length}/${characterLimit}`}
            name={name}
            onChange={change => changeMessage(change.currentTarget.value)}
            placeholder={isEmpty(message) ? placeholder : ''}
            value={message}
          />
        </Form>
      </Formik>
    </div>
  )
}
export default GiftCardMessageInput
